import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toFullDate, toMonthYearDate } from '@/modules/core/utils/formats';

export const getVisionTwoCharts = async(options) => {
  const params = {
    quantidadeDias: options.days,
    tipoValor: options.valueType,
    status: options.status,
    usuariosIds: options.users || '',
    servicosIds: options.servicos || '',
    clientesIds: options.clientes || '',
  };
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`dashboard/graficoVendas?${new URLSearchParams(params).toString()}`);
  const total = response.data.reduce((total, value) => total + value.valor, 0);
  const x = response.data.map((value) => value.valor);
  const y = dateFormat(options.days, response.data);
  return { total, x, y };
};

const dateFormat = (days, data) => {
  if (days < 61) {
    return data.map((value) => toFullDate(value.dataCriacao));
  } else {
    return data.map((value) => toMonthYearDate(value.dataCriacao));
  }
};
